<template>
  <div class="buyer-campaigns-filter flex flex-wrap">
    <div class="flex-shrink w-auto">
      <date-range-filter
        v-model="runDate"
        class="w-auto"
        @change="change({ start_date: $event })"
      />
    </div>
    <div class="text-right overflow-scroll-x flex-grow mt-0">
      <buyer-ads-filter-data-query>
        <template slot-scope="{ data: buyer }">
          <div v-if="buyer" class="flex flex-wrap justify-end">
            <div class="flex-shrink ml-3">
              <custom-el-select
                v-model="statuses"
                :options="CampaignStatuses"
                @change="change({ status: $event })"
              />
            </div>
            <div class="flex-shrink ml-3">
              <export-button
                :is-exporting="isExporting"
                @click="exportCampaigns"
              />
            </div>
          </div>
          <loader-content v-else>
            <loader-text :lines="1" :line-width="80"></loader-text>
          </loader-content>
        </template>
      </buyer-ads-filter-data-query>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { download } from '@/utils/helpers';
import { CampaignStatusInfo } from '@/constants';

import DateRangeFilter from '@/components/Core/Table/Filters/DateRangeFilter';
import ExportButton from '@/components/Core/Table/ExportButton';
import CustomElSelect from '@/components/Custom/CustomElSelect';
import { BuyerAdsFilterDataQuery } from '@/components/Queries';
import { LoaderContent, LoaderText } from '@/components/Core/Loaders';

export default {
  components: {
    BuyerAdsFilterDataQuery,
    DateRangeFilter,
    ExportButton,
    LoaderContent,
    LoaderText,
    CustomElSelect
  },
  props: {
    filter: { type: Object, default: null }
  },

  data() {
    let minDate = this.filter.start_date ? this.filter.start_date['>='] : '';
    let maxDate = this.filter.start_date ? this.filter.start_date['<='] : '';

    return {
      CampaignStatuses: Object.values(CampaignStatusInfo),
      runDate: [minDate, maxDate],
      statuses: [],
      isExporting: false
    };
  },

  methods: {
    change(change) {
      let filter = { ...this.filter, ...change };
      this.$emit('update:filter', filter);
      this.$emit('change', filter);
    },

    exportCampaigns() {
      let params = {
        filter: this.filter
      };

      this.isExporting = true;

      axios
        .post(
          '/buyer/' +
            this.$store.getters['auth/buyerId'] +
            '/campaigns/export/local',
          params
        )
        .then(({ data }) => {
          this.isExporting = false;

          if (data.success) {
            download(data.csv, data.name);
          }
        });
    }
  }
};
</script>
